import TextField, { TextFieldProps } from "@mui/material/TextField";

const CustomTextarea: React.FC<TextFieldProps> = ({ ...props }) => (
  <TextField fullWidth minRows={3} maxRows={10} {...props} multiline />
);

export default CustomTextarea;
